import styles from './MainOurPressContentBox.module.scss'
import Harpoon from 'public/images/harpoon-right.svg'
import OurPressDataType from 'src/types/OurPressDataType'

export default function MainOurPressContentBox(props: OurPressDataType) {
  const { headLine, press, onClick } = props
  return (
    <div 
      className={ styles.MainOurPressContentBox }
      onClick={ onClick }
    >
      <p className={ styles.headLine }>{ headLine }</p>
      <p className={ styles.press }>{ press }</p>
      <Harpoon className={ styles.harpoon }/>
    </div>
  )
}
